<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-04 19:29:28
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-09 11:42:48
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\components\element\select.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang="jsx">
export default {
  name: 'ESelect',
  props: {
    options: {
      //选项列表
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    return () => (
      <el-select>
        {props.options.map((e) => (
          <el-option {...e} />
        ))}
      </el-select>
    );
  },
};
</script>
